import { Workbook } from "exceljs";
import saveAs from "file-saver";

function calculateRowHeight(content: string, columnWidth: number): number {
  const lineBreaks = content.split("\n").length - 1; // Number of line breaks
  const averageCharsPerLine = columnWidth * 1.2; // Adjustment factor
  const linesByLength = Math.ceil(content.length / averageCharsPerLine);
  const totalLines = Math.max(linesByLength, lineBreaks + 1);
  const heightPerLine = 15; // Approximate height per line in points
  return totalLines * heightPerLine;
}

export const excelExport = async (
  columns: { header: string; key: string; width: number }[],
  data: Record<string, any>[],
  fileName: string,
  title: string = "1"
) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(title, {
    properties: { tabColor: { argb: "FFC0000" } },
  });
  worksheet.columns = columns;

  for (const row of data) {
    const r = worksheet.addRow(row);
    r.alignment = { wrapText: true };
  }

  worksheet.columns.forEach((column) => {
    let minLength = 10; // Minimum column width
    let maxLength = 60; // Maximum column width
    // @ts-ignore
    column.eachCell({ includeEmpty: true }, (cell) => {
      const cellValue = cell.value ? cell.value.toString() : "";
      const cellLines = cellValue.split("\n");
      cellLines.forEach((line) => {
        minLength = Math.min(Math.max(minLength, line.length), maxLength);
      });
    });
    column.width = minLength + 2; // Add some padding
  });

  // Estimate and set row heights
  worksheet.eachRow((row) => {
    let maxHeight = 15; // Minimum row height

    row.eachCell({ includeEmpty: true }, (cell) => {
      const columnWidth = worksheet.getColumn(cell.col).width || 10;
      const cellContent = cell.value ? cell.value.toString() : "";
      const estimatedHeight = calculateRowHeight(cellContent, columnWidth);

      if (estimatedHeight > maxHeight) {
        maxHeight = estimatedHeight;
      }
    });

    row.height = maxHeight;
  });

  const excelBuffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([excelBuffer], { type: fileType });
  await saveAs(blob, fileName);
};
